import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classname';

const Edit = ({ width, height, className, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24" 
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    class="feather feather-edit-2">
    <polygon points="16 3 21 8 8 21 3 21 3 16 16 3"></polygon>
  </svg>
);

Edit.defaultProps = {
  width: 16,
  height: 16,
  color: '#237CFB',
};

Edit.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  color: PropTypes.string,
};

export default Edit;
